<template>
  <div class="container load-previous">
    <div class="row">
      <div class="col-sm-12">
        <div class="title-wrapper">
          <h1 class="title">Load your previous results</h1>
        </div>
        <div class="title-divider"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="image-wrapper">
          <img src="/img/analytics.svg" alt="analytics"/>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="description-wrapper">
          <p>
            If you have previously taken this hearing test through Lloyd
            Hearing Aid or are a previously registered user from Fennex by
            Smart Hear application, you can load your previous hearing test
            results by entering your email and password associated with your
            account.
          </p>
          <p>
            If you have never taken this hearing test before you may skip this
            step.
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-4 offset-md-3 offset-lg-4">
        <div class="form-wrapper">
          <form ref="form" class="needs-validation" novalidate>
            <div class="form-row">
              <input
                v-model="email"
                type="email"
                class="form-control"
                id="email"
                placeholder="E-mail"
                required
              />
              <div class="invalid-feedback">
                Please enter a valid e-mail address
              </div>
            </div>
            <div class="form-row">
              <input
                v-model="password"
                type="password"
                class="form-control"
                id="password"
                placeholder="Password"
                required
              />
              <div class="invalid-feedback">
                Please enter your password
              </div>
            </div>
            <div class="button-wrapper">
              <button @click.prevent="loadResults" class="btn button-main" type="submit">Load</button>
              <button @click.prevent="skip"  class="button-minor">Skip</button>
            </div>
            <div v-show="showAlert" class="alert alert-danger" role="alert">
              {{ alertText }}
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {usersCollection, auth} from "../store/firebaseConfig";

  export default {
    data() {
      return {
        email: '',
        password: '',
        showAlert: false,
        alertText: "Something went wrong",
      }
    },
    methods: {
      async loadResults() {
        this.showAlert = false
        this.alertText = "Something went wrong"

        this.$refs.form.classList.add("was-validated")
        if (this.$refs.form.checkValidity() === false) return

        try {
          let user = (await auth.signInWithEmailAndPassword(this.email, this.password)).user
          let userData = (await usersCollection.doc(user.uid).get()).data()

          this.$store.commit('setGender', userData.gender)
          this.$store.commit('setAge', userData.age)
          this.$store.commit('setSource', userData.source)
          this.$store.commit('setResults', {
            originalL: userData.htLeft,
            originalR: userData.htRight
          })
          this.$store.commit('setLoadedResults', true)

          await this.$router.push('/hearing-loss-results')
        } catch (e) {
          console.log(e)
          this.alertText = e.message
          this.showAlert = true
        }
      },
      skip(){

        this.$store.commit('setLoadedResults', false)

        this.$router.push('/select-gender')
      }
    }
  }
</script>
